<template>
    <div>
        <div class="input-with-icon">
            <input
                id="autocomplete-input"
                type="text"
                v-model="searchStr"
                :placeholder=placeholder
                style="border-color: yellow;"
                @input="updateSearchStr()"
            />
            <i><span class="search-info" v-text="searchInfo"></span></i>
            <i :class=iconClass><span style="font-size: .8rem;"></span></i>
        </div>

<!--        <div class="intro-search-button">-->
<!--                <button-->
<!--                    class="button ripple-effect"-->
<!--                    onclick="window.location.href='jobs-list-layout-full-page-map.html'"-->
<!--                >-->
<!--                    Search-->
<!--                </button>-->
<!--        </div>-->
<!--        <span style="margin-top: -10px; font-size: .5rem;">Min of 7 char.</span>-->

    </div>
</template>
<script>
    export default {
        name: 'search',
        props: ['placeholder', 'icon', 'min_len'],
        data() {
            return {
                searchStr: '',
                searchInfo: '',
            }
        },

        computed: {
            iconClass() {
              return `icon-material-outline-${this.icon}`;
            },
        },
        methods: {
            updateSearchStr() {
                //sends event if str length is more th
                if (this.searchStr.length >= this.min_len || this.searchStr === '') {
                    this.$emit('searchstr', this.searchStr )
                }

                if (this.searchStr.length < this.min_len && this.searchStr.length !== 0) {
                    this.searchInfo = `At least ${this.min_len} chars ${this.min_len - this.searchStr.length} more`;
                } else {
                    this.searchInfo = '';
                }
            },
        },
    }
</script>

<style scoped>
    .search-info {
        font-size: .8rem;
        margin-right: 20px;
        color: #73d90c;
    }
</style>